<script setup lang="ts">
import { ToccoCourseFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'
import { useSchemaToccoBase } from '~/composables/useSchemaToccoBase'

useNoCache()

const props = withDefaults(
  defineProps<{
    entity: ToccoCourseFieldsFragment
    breadcrumbs?: Link[]
  }>(),
  {
    breadcrumbs: () => [],
  },
)

// Add schema.org JSON-LD structured data
useSchemaToccoBase(props.entity, 'course')
</script>

<template>
  <ToccoBase :entity="entity" :breadcrumbs="breadcrumbs" />
</template>
